import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'box-info-ocurrence',
  templateUrl: './box-info-ocurrence.component.html',
  styleUrls: ['./box-info-ocurrence.component.css']
})
export class BoxInfoOcurrenceComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
